module.exports = __webpack_public_path__ + "img/logo.0b117a1b.svg";